import React, { useCallback } from 'react';
import { BreakReminderModal } from './BreakReminderModal';
import { useReminderToShow } from './useReminderToShow';
import {
  useDefaultBreakTypeId,
  usePauseTimeTracking,
} from '../../../hooks/timeTracking';
import { useAutoBreaksTimeTrackingFeatures } from '../useAutoBreaksTimeTrackingFeatures';

export const BreakReminders: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const features = useAutoBreaksTimeTrackingFeatures();
  if (features.reminders) {
    return <BreakRemindersInternal />;
  }
  return null;
};

const BreakRemindersInternal: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { reminderToShowId, closeReminderModal, currentTimeEntryId } =
    useReminderToShow();

  const { pauseTimeTracking } = usePauseTimeTracking(currentTimeEntryId!);
  const defaultBreakTypeId = useDefaultBreakTypeId();

  const handleClose = useCallback(() => {
    if (reminderToShowId) {
      closeReminderModal(reminderToShowId);
    }
  }, [reminderToShowId, closeReminderModal]);

  const handleStartBreak = useCallback(() => {
    if (!currentTimeEntryId) {
      return;
    }
    pauseTimeTracking(defaultBreakTypeId).finally(() => {
      handleClose();
    });
  }, [currentTimeEntryId, defaultBreakTypeId, pauseTimeTracking, handleClose]);

  return (
    <BreakReminderModal
      visible={reminderToShowId !== null}
      onStartBreak={handleStartBreak}
      onClose={handleClose}></BreakReminderModal>
  );
};
